<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="modelId ? `Edición perfil de ${modelName}` : 'Nuevo Perfil'"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>

		<b-form>
			<b-card no-body>
				<b-tabs pills card vertical>
					<b-tab
						:title="item.module"
						v-for="(item, i) of permissions"
						:key="i"
					>
						<PermissionList :unableEdit="unableEdit" v-if="item.permissions" :item="item" />
						<div v-else>
							<PermissionList
								:unableEdit="unableEdit"
								v-for="(child, j) of item.children"
								:key="j"
								:item="child"
							/>
						</div>
					</b-tab>
				</b-tabs>
			</b-card>

			<div class="text-right mt-4">
				<hr />
				<b-button variant="primary" :disabled="unableEdit" block @click="save()"
					>Guardar</b-button
				>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
import permissionService from "@/services/permissions/permissions.service";
import PermissionList from "./PermissionList";
import { mapState, mapMutations } from "vuex";
export default {
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {
		PermissionList
	},
	data() {
		return {
			modelId: null,
			modelName: null,
			loading: true,
			permissions: []
		};
	},
	computed: {
		...mapState("permission", ["permissionsChecked"])
	},
	methods: {
		...mapMutations("permission", ["RESET_PERMISSION"]),
		save() {
			this.loading = true;
			this.$root.api
				.put(`/profiles/${this.modelId}/permissions`, {
					permissions: this.permissionsChecked
				})
				.then(res => {
					this.RESET_PERMISSION();
					this.$root.showAlert(
						"Se modifico correctamente los permisos del perfil"
					);
					this.successCallback(res);
					this.$refs["modal-view"].hide();
				})
				.catch(this.$root.handleRequestError)
				.finally(() => (this.loading = false));
		},
		loadModel(id, name) {
			this.modelId = id;
			this.modelName = name
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		fetchModel() {
			if (this.modelId) {
				this.loading = true;
				this.permissions = [];
				this.$root.api
					.get(`/permissions`)
					.then(response => {
						const permissionsAvailable = response.data.permissions;
						this.$root.api
							.get(`/profiles/${this.modelId}/permissions`)
							.then(res => {
								this.$emit('update:unableEdit',!this.$hasPermission("profile.permission.edit"))
								const permissionsUsed = res.data.permissions;
								this.RESET_PERMISSION(permissionsUsed);
								this.permissions = permissionService.buildStructure(
									permissionsAvailable,
									permissionsUsed || []
								);
							});
					})
					.catch(this.$root.handleRequestError)
					.finally(() =>
						setTimeout(() => (this.loading = false), 1000)
					);
			}
		}
	}
};
</script>

<style></style>
